import React from 'react';
import { stats } from '../data/hockey';
export function StatsBar() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100" data-id="element-273" data-mp="1tai3vek6szsx">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-12" data-id="element-274" data-mp="1t8dq84whkmfg">
        <h2 className="shrink-0 font-serif text-2xl italic leading-tight text-red-700 lg:w-44" data-id="element-275" data-mp="1odhyl5v5w12v">
          The Complete Bundle in Numbers
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-4 lg:mt-0 lg:flex-1" data-id="element-276" data-mp="1edhbr9y332tx">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-slate-900/15 pl-5" data-id="element-277" data-mp="19lg0nrcnji5h">
              <dt className="mt-3 text-sm leading-snug text-slate-900/70" data-id="element-278" data-mp="15lp6rertwlwq">{stat.label}</dt>
              <dd className="font-serif text-6xl leading-none tracking-tight text-slate-900" data-id="element-279" data-mp="10mvpdb9f8ara">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}